import { render, staticRenderFns } from "./deveTower.vue?vue&type=template&id=13da2586&scoped=true&"
import script from "./deveTower.vue?vue&type=script&lang=js&"
export * from "./deveTower.vue?vue&type=script&lang=js&"
import style0 from "./deveTower.vue?vue&type=style&index=0&id=13da2586&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13da2586",
  null
  
)

export default component.exports